<miq-tag-editor-wrapper
  [tags]="tags"
  [canEdit]="canEdit"
  [filterUrl]="filterUrl"
  [entityId]="entityId"
  (tagsChanged)="onTagsChanged($event)"
></miq-tag-editor-wrapper>
